import React from "react";
import NucleoFamiliareList from "./NucleoFamiliareList";

const CartellaSocialeReadOnly = ({ cartellaSociale }) => {
  if (!cartellaSociale) {
    return <p className="text-muted">Nessuna cartella sociale presente</p>;
  }

  return (

<div className="card card-bg no-after card-big roundedCustom">
  <div className="card-body">
    <h5 className="card-title">Cartella Sociale</h5>

    <div className="row">
      <div className="col-md-6">
        <strong>Reddito:</strong>{" "}
        {cartellaSociale.reddito ?? "—"}
      </div>

      <div className="col-md-6">
        <strong>Cittadinanza italiana:</strong>{" "}
        {cartellaSociale.cittadinanzaItaliana === true
          ? "Sì"
          : cartellaSociale.cittadinanzaItaliana === false
          ? "No"
          : "—"}
      </div>
    </div>

    <div className="row mt-3">
      <div className="col-md-6">
        <strong>IBAN:</strong>{" "}
        {cartellaSociale.iban ?? "—"}
      </div>

      <div className="col-md-6">
        <strong>Intestatario IBAN:</strong>{" "}
        {cartellaSociale.ibanIntestatario ?? "—"}
      </div>
    </div>

    <hr />

    <NucleoFamiliareList
      nucleoFamiliare={cartellaSociale.nucleoFamiliare}
    />
  </div>
</div>
  );
};

export default CartellaSocialeReadOnly;
